import { connect } from 'react-redux';
import ClientRow from './ClientRow';
// import { projectStatusLoading } from '../../../../../store/selectors/projecte.selector';
import { sortClientRequest, updateClientFlag } from '../../../../../store/actions/clients.actions';

const mapDispatchToProps = { sortClientRequest, updateFlag: updateClientFlag };

const mapStateToProps = (state) => { 
    // const statusLoading = updateProjectStatus(state);

    return { };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ClientRow);